/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, createRef } from "react"; // React Stuff
import { BrowserView, MobileView } from "react-device-detect"; // Device Detection for two views
import withRouter from "../WithRouter";
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";
import ReturnButton from "../common/ReturnButton";
//Packages
import axios from "axios";
import { Container, Tabs, Tab, Col, Row, Form } from "react-bootstrap";
import { isAuthenticated } from "./services/auth"; //import auth
import { Navigate } from "react-router-dom";
//Subcomponents
import SetTutor from "./page-parts/SetTutor";
import ClassInfo from "./page-parts/ClassInfo";
import ClassSubscribers from "./page-parts/ClassSubscribers";
import ClassWaitingList from "./page-parts/ClassWaitingList";
import ClassTransferSubscription from "./page-parts/ClassTransferSubscription";
import ClassRegisterTab from "./page-parts/ClassRegisterTab";
import ClassUpdate from "./page-parts/ClassUpdate";
import ClassDelete from "./page-parts/ClassDelete";
import ClassIssueReports from "./page-parts/ClassIssueReports";
import LoadingSpinner from "../LoadingSpinner";

const RegularClassManage = (props) => {
  const [classData, setClassData] = useState({});
  const [tutors, setTutors] = useState([]);
  const [classTypes, setClassTypes] = useState([]);
  const [viewMode, setViewMode] = useState("classinfo");
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // Extract the class ID
  const classid = props.params.classid;
  const prevClassId = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  // Get the class data and set it
  useEffect(async () => {
    prevClassId.current = classid; // Assign Refs Value to current load
    // Get the Class Data
    const classDataRequest = await axios.get(`/api/admin/manage/classes/${classid}`, {
      withCredentials: true,
    });
    // Get the List of Tutors for Setting
    const tutorListRequest = await axios.get(`/api/admin/manage/tutor`, {
      withCredentials: true,
    });
    // Get the Class Types for Settings
    const classTypeRequest = await axios.get(`/api/admin/manage/class_types`, {
      withCredentials: true,
    });
    setClassTypes(classTypeRequest.data);
    setTutors(tutorListRequest.data);
    return setClassData(classDataRequest.data);
  }, [classid]); // Run useEffect when the classID changes to get new class data.

  //Fetch new data if a subcomponent calls for it.
  const fetchNewData = async () => {
    const classDataRequest = await axios.get(`/api/admin/manage/classes/${classid}`, {
      withCredentials: true,
    });
    return setClassData(classDataRequest.data);
  };

  // CreateRef to handle Alerts and scroll
  const alerts = createRef();
  const scrollSmoothHandler = () => {
    return alerts.current.scrollIntoView({ behavior: "smooth" });
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='ClassList' key={classid}>
      <FadeIn delay={250} duration={450}>
        {isAuthenticated() ? (
          <Container>
            <div ref={alerts}>
              <StatusBlock
                errorMessage={errorMessage}
                successMessage={successMessage}
                dismissMessages={dismissMessages}
              />
            </div>
            {classData._id ? (
              <>
                <BrowserView>
                  <Tabs defaultActiveKey='classinfo' id='uncontrolled-tabs' className='text-center'>
                    <Tab eventKey='classinfo' title='Overview'>
                      <ClassInfo data={classData} />
                    </Tab>
                    <Tab eventKey='tutor' title='Tutor'>
                      <SetTutor
                        data={classData}
                        tutors={tutors}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                        BookingType="regular"
                      />
                    </Tab>

                    <Tab eventKey='subscriptions' title='Subscriptions/Learners'>
                      <ClassSubscribers
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>

                    <Tab eventKey='waitinglist' title='Waiting List'>
                      <ClassWaitingList
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>
                    <Tab eventKey='transfer' title='Transfer Learner'>
                      <ClassTransferSubscription
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>

                    <Tab eventKey='register' title='Registers'>
                      <ClassRegisterTab
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>
                    <Tab eventKey='progress' title='Progress &amp; Awards'>
                      <ClassIssueReports data={classData} />
                    </Tab>
                    <Tab eventKey='edit' title='Edit Details'>
                      <ClassUpdate
                        scrollSmoothHandler={scrollSmoothHandler}
                        data={classData}
                        classTypes={classTypes}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>

                    <Tab eventKey='delete' title='Delete Class'>
                      <ClassDelete
                        data={classData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </Tab>
                  </Tabs>
                </BrowserView>
                <MobileView>
                  <ModeSelect viewMode={viewMode} setViewMode={setViewMode} />
                  {viewMode === "classinfo" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassInfo data={classData} />
                    </FadeIn>
                  )}
                  {viewMode === "tutor" && (
                    <FadeIn delay={250} duration={450}>
                      <SetTutor
                        data={classData}
                        tutors={tutors}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                        BookingType="regular"
                      />
                    </FadeIn>
                  )}
                  {viewMode === "subscriptions" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassSubscribers
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                  {viewMode === "waitinglist" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassWaitingList
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                  {viewMode === "transfer" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassTransferSubscription
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                  {viewMode === "register" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassRegisterTab
                        data={classData}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                  {viewMode === "progress" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassIssueReports data={classData} />
                    </FadeIn>
                  )}
                  {viewMode === "edit" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassUpdate
                        scrollSmoothHandler={scrollSmoothHandler}
                        data={classData}
                        classTypes={classTypes}
                        fetchNewData={fetchNewData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                  {viewMode === "delete" && (
                    <FadeIn delay={250} duration={450}>
                      <ClassDelete
                        data={classData}
                        submitClicked={submitClicked}
                        setSubmitClicked={setSubmitClicked}
                        setErrorMessage={setErrorMessage}
                        setSuccessMessage={setSuccessMessage}
                      />
                    </FadeIn>
                  )}
                </MobileView>
                <Row>
                  <Col className='text-center' sm='12'>
                    <ReturnButton />
                  </Col>
                </Row>
              </>
            ) : (
              <LoadingSpinner />
            )}
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

const ModeSelect = (props) => {
  return (
    <Row>
      <Col>
        <Form className='mt-3 text-center'>
          <Form.Label>Choose Tab</Form.Label>
          <Form.Control
            as='select'
            value={props.viewMode}
            onChange={(e) => props.setViewMode(e.target.value)}
            custom
            className='border'
          >
            <option value='' disabled defaultValue>
              Select Option
            </option>
            <option value='classinfo'>Info</option>
            <option value='tutor'>Tutor</option>
            <option value='subscriptions'>Subscriptions/Learners</option>
            <option value='waitinglist'>Waiting List</option>
            <option value='transfer'>Transfer Learner</option>
            <option value='register'>Registers</option>
            <option value='edit'>Edit Class</option>
            <option value='progress'>Progress &amp; Awards</option>
            <option value='delete'>Delete Class</option>
          </Form.Control>
        </Form>
      </Col>
    </Row>
  );
};

export default withRouter(RegularClassManage);
